import '../layout/Box.js';
import { Stack } from '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
import styled from 'styled-components';
var TableHead = styled(Stack)({});
TableHead.defaultProps = {
  fontWeight: 600,
  backgroundColor: "grey.4",
  borderRadius: "16px",
  margin: "8px",
  align: "center"
};
export { TableHead };